import { useState } from 'react';
import { IconCircleCheck } from '@tabler/icons-react';
import { Anchor } from '@mantine/core';
import { Button, Modal, Stack, Text } from '@datavant/dart';
import { trpc } from '../../utils/trpc';
import { RmV2SupportView } from './RmV2SupportView';

export const RmV2CompletedModal = (): JSX.Element => {
    const { data } = trpc.requestManager.getRmV2MigratedState.useQuery();
    const [showSupport, setShowSupport] = useState(false);
    const providerAppUrl = data?.providerAppUrl ?? 'https://provider.datavant.com';

    return (
        <Modal
            opened
            onClose={() => undefined}
            withCloseButton={false}
            closeOnClickOutside={false}
            closeOnEscape={false}
            size={520}
            centered
            styles={{ body: { padding: 'var(--mantine-spacing-xl)' } }}
        >
            {showSupport ? (
                <RmV2SupportView onBack={() => setShowSupport(false)} />
            ) : (
                <Stack gap="lg" align="center">
                    <IconCircleCheck size={64} strokeWidth={1.5} color="var(--mantine-color-teal-4)" />
                    <Text fw={700} fz="xl" ta="center">
                        You&apos;ve already completed your upgrade
                    </Text>
                    <Text size="sm" ta="center">
                        Head to the upgraded Request Manager to access your records.
                    </Text>
                    <Button
                        intent="prominent"
                        fullWidth
                        onClick={() => window.open(providerAppUrl, '_blank')}
                    >
                        Go to upgraded Request Manager
                    </Button>
                    <Text size="sm" c="dimmed" ta="center">
                        Need help?{' '}
                        <Anchor component="button" size="sm" onClick={() => setShowSupport(true)}>
                            Contact Support
                        </Anchor>
                    </Text>
                </Stack>
            )}
        </Modal>
    );
};
